import React, { useState, useEffect, useCallback } from "react";
import { Star, Plus, Trash2, GripVertical } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function FavouritesBar() {
  const [favs, setFavs] = useState([]);
  const [adding, setAdding] = useState(false);
  const [newPath, setNewPath] = useState("");
  const [newLabel, setNewLabel] = useState("");

  const fetchFavs = useCallback(async () => {
    const res = await fetch(`${API}/api/favourites`, { credentials: "include" });
    if (res.ok) {
      const data = await res.json();
      setFavs(data.favourites || []);
    }
  }, []);

  useEffect(() => { fetchFavs(); }, [fetchFavs]);

  const addFav = async () => {
    if (!newPath || !newLabel) return;
    await fetch(`${API}/api/favourites`, {
      method: "POST", credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: newPath, label: newLabel }),
    });
    setNewPath(""); setNewLabel(""); setAdding(false);
    fetchFavs();
  };

  const removeFav = async (path) => {
    const cleanPath = path.startsWith("/") ? path.substring(1) : path;
    await fetch(`${API}/api/favourites/${cleanPath}`, { method: "DELETE", credentials: "include" });
    fetchFavs();
  };

  if (!favs.length && !adding) {
    return (
      <div className="px-3 py-2" data-testid="favourites-bar">
        <button onClick={() => setAdding(true)}
          className="flex items-center gap-1.5 text-[10px] text-[#555] hover:text-[#C9A84C] w-full py-1">
          <Star size={12} /> Add shortcut
        </button>
      </div>
    );
  }

  return (
    <div className="px-3 py-2 border-b border-[rgba(255,255,255,0.04)]" data-testid="favourites-bar">
      <div className="flex items-center justify-between mb-1">
        <span className="text-[9px] text-[#555] uppercase tracking-wider">Shortcuts</span>
        <button onClick={() => setAdding(!adding)} className="text-[#8B95A5] hover:text-[#C9A84C]">
          <Plus size={12} />
        </button>
      </div>
      {favs.map(f => (
        <div key={f.path} className="flex items-center justify-between group">
          <a href={f.path} className="flex items-center gap-1.5 text-xs text-[#8B95A5] hover:text-white py-0.5 flex-1"
            data-testid={`fav-${f.path}`}>
            <Star size={10} className="text-[#C9A84C]" /> {f.label}
          </a>
          <button onClick={() => removeFav(f.path)}
            className="opacity-0 group-hover:opacity-100 text-[#555] hover:text-[#F87171]"
            data-testid={`remove-fav-${f.path}`}>
            <Trash2 size={10} />
          </button>
        </div>
      ))}
      {adding && (
        <div className="mt-1 space-y-1">
          <input value={newPath} onChange={e => setNewPath(e.target.value)} placeholder="/path"
            className="w-full bg-[#0D0F14] border border-[rgba(255,255,255,0.1)] rounded px-2 py-1 text-[10px] text-white"
            data-testid="new-fav-path" />
          <input value={newLabel} onChange={e => setNewLabel(e.target.value)} placeholder="Label"
            className="w-full bg-[#0D0F14] border border-[rgba(255,255,255,0.1)] rounded px-2 py-1 text-[10px] text-white"
            data-testid="new-fav-label" />
          <button onClick={addFav} className="w-full py-1 bg-[#C9A84C] text-[#0D0F14] rounded text-[10px] font-semibold"
            data-testid="add-fav-btn">Add</button>
        </div>
      )}
    </div>
  );
}
